import { createReducer } from '__common/utils/helpers';
import { RailsSelectorActionTypes } from 'actionsConstants';
import { getDefaultSelectedRails } from './railsSelector';
import { applyAdd185InchRail, applyAdd185InchRailForSML } from '__common/utils/versionCompare/versionCompare';

export const railsSelectorState: railsSelectorState = {
  railsList: [],
  railsLoaded: false,
  railsFetching: false,
  selectOnlySMHDRails: false,
  pendingRailLengths: [],
};

function railLengthsFromSelection(selectedRails: any[]): number[] {
  if (!Array.isArray(selectedRails)) return [];
  return selectedRails
    .map((rail) => (typeof rail === 'number' ? rail : rail && rail.length))
    .filter((length) => typeof length === 'number' && length > 0);
}

function applyRailLengths(railsList: rail[], lengths: number[]): rail[] {
  if (!lengths || !lengths.length) return railsList;
  return railsList.map((rail) => ({
    ...rail,
    selected: lengths.includes(rail.length),
  }));
}

export default {
  railsSelector: createReducer(railsSelectorState, {
    [RailsSelectorActionTypes.FETCH_RAILS](state: railsTypeChangerState) {
      return { ...state, railsLoaded: false };
    },
    [RailsSelectorActionTypes.FETCHING_RAILS](state: railsSelectorState){
      return { ...state, railsFetching: true };
    },
    [RailsSelectorActionTypes.SELECT_ALL_RAILS](state: railsSelectorState) {
      const railsLength = state.railsList.length;
      const allSelectedRails = state.railsList.map((rail: rail) => { 
        if(railsLength >= 5 && rail.length === 185){
          rail.selected = false;
        }
        else{
          rail.selected = true;
        }
        return rail;
      });
      return { ...state, railsList: allSelectedRails };
    },

    [RailsSelectorActionTypes.SELECT_LOWEST_COST_RAILS_FOR_185](state: railsSelectorState) {
      const allSelectedRails = state.railsList.map((rail: rail) => { 
        if([132, 185, 246].includes(rail.length)){
          rail.selected = true;
        }
        else{
          rail.selected = false;
        }
        return rail;
      });
      return { ...state, railsList: allSelectedRails };
    },

    [RailsSelectorActionTypes.SELECT_DEAFULT_RAILS](state: railsSelectorState, action) {
      const { productId, railFinish, projectConfiguration } = action.payload;
      const mockCurrentState = projectConfiguration ? { projectConfiguration } : undefined;
      const defaultRails = getDefaultSelectedRails(productId, railFinish, mockCurrentState as appState);
      const defaultSelectedRails = state.railsList.map((rail) => {
        if (defaultRails.includes(rail.length)) {
          rail.selected = true;
        } else {
          rail.selected = false;
        }
        return rail;
      });

      return { ...state, railsList: defaultSelectedRails };
    },
    [RailsSelectorActionTypes.SELECT_RAIL](state: railsSelectorState, action) {
      const { payload: { length } } = action;
      const railsList = state.railsList.map((rail) => {
        if (rail.length === length) {
          rail.selected = true;
        }
        return rail;
      });
      return { ...state, railsList };
    },
    [RailsSelectorActionTypes.UNSELECT_RAIL](state, action) {
      const { payload: { length } } = action;
      const railsList = state.railsList.map((rail) => {
        if (rail.length === length) {
          rail.selected = false;
        }
        return rail;
      });
      return { ...state, railsList };
    },
    [RailsSelectorActionTypes.LOAD_RAILS_LIST](state: railsSelectorState, action) {
      const { railsList } = action.payload;
      // The list from the BOM page already has selected flags from
      // extra_parameters.selections.selected_rails. Do not replace those with
      // rail_lengths from a regenerated BOM (those are product defaults after
      // an attachment-type change deletes the SelectedRailLengths row).
      const incomingHasSelection = Array.isArray(railsList) && railsList.some((rail) => rail && rail.selected);
      return {
        ...state,
        railsList: incomingHasSelection ? railsList : applyRailLengths(railsList, state.pendingRailLengths || []),
        pendingRailLengths: [],
      };
    },
    [RailsSelectorActionTypes.CLEAR_RAILS_LIST](state: railsSelectorState) {
      return { ...state, railsList: [], railsLoaded: false, railsFetching: false, railTypeLoaded: false, pendingRailLengths: [] };
    },
    [RailsSelectorActionTypes.SELECT_RAILS_FROM_API](state: railsSelectorState, action) {
      if (!action.payload.applySelection) {
        return state;
      }
      const { railsList } = state;
      const lengths = railLengthsFromSelection(action.payload.selectedRails);

      // The BOM page clears the rail list before the fetch returns. Hold the
      // saved lengths until LOAD_RAILS_LIST builds the checkboxes.
      if (!railsList.length) {
        return { ...state, pendingRailLengths: lengths };
      }

      return { ...state, railsList: applyRailLengths(railsList, lengths), pendingRailLengths: [] };
    },
    [RailsSelectorActionTypes.RAILS_LOADED](state) {
      return { ...state, railsLoaded: true, railsFetching: false };
    },
    [RailsSelectorActionTypes.SELECT_ONLY_SMHD_RAILS](state) {
      return { ...state, selectOnlySMHDRails: true };
    },
    [RailsSelectorActionTypes.UNSELECT_ONLY_SMHD_RAILS_OPTION](state) {
      return { ...state, selectOnlySMHDRails: false };
    },
  }),
};

